// Text with .text-reveal is split into masked lines, on in-view (or on intro with .reveal-on-intro) each line moves up out of its mask and fades in
class TextReveal {
    constructor() {
        // On mobile the layout can still shift right after load, splitting too early leaves lines that wrap within their mask
        const splitDelay = window.matchMedia('(max-width: 800px)').matches ? 500 : 0;

        document.querySelectorAll('.text-reveal').forEach((element) => {
            setTimeout(() => this.split(element), splitDelay);
        });
    }

    split(element) {
        // autoSplit splits again when the fonts are loaded and when the width changes
        SplitText.create(element, {
            type: 'lines',
            linesClass: 'line',
            mask: 'lines',
            autoSplit: true,
            onSplit: (split) => {
                split.lines.forEach((line, index) => line.style.setProperty('--line-index', index));
            }
        });

        // Wait for the fonts (autoSplit re-splits then, new lines would skip the transition)
        // .is-split makes the element visible with the lines still hidden, the short wait makes sure that state is painted first
        document.fonts.ready.then(() => {
            element.classList.add('is-split');

            setTimeout(() => {
                // .reveal-on-intro reveals right away (start-intro is already set by then) instead of on scroll
                if (element.classList.contains('reveal-on-intro')) {
                    element.classList.add('in-view');
                    return;
                }

                ScrollTrigger.create({
                    trigger: element,
                    start: 'top 85%',
                    once: true,
                    onEnter: () => element.classList.add('in-view')
                });
            }, 100);
        });
    }
}
new TextReveal();
